import React from 'react';
export function SectionLabel({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="neon-text-soft mb-6 flex items-center gap-3 text-[11px] uppercase tracking-label text-gold-500" data-id="element-196" data-mp="3c5z9blj8w4iw">
      <span className="neon-divider h-px w-8 bg-gold-500/70" aria-hidden="true" data-id="element-197" data-mp="2yflzteqpghrg" />
      {children}
    </p>;
}